export enum AppointmentStatus {
	ATTENDED = "ATTENDED",
	PENDING = "PENDING",
	CANCELLED_REFUND = "CANCELLED_REFUND",
	NOT_ATTENDED = "NOT_ATTENDED"
}
